import { TBColumn } from '../../interfaces/TableBits.interfaces';
const columns: TBColumn[] = [
    {
        id: "Fecha",
        label: 'Fecha',
        align: 'left',
    },
    {
        id: "Comentario",
        label: 'Comentario',
        align: 'left',
    },
    {
        id: "Usuario",
        label: 'Usuario',
        align: 'left',
    },
];

export default columns;